import React, { useState, useEffect, useRef } from 'react';
import { Line } from '@ant-design/plots';
import { Card } from 'antd';
import { ContextMenuTrigger, ContextMenu, ContextMenuItem } from 'rctx-contextmenu';

const LinePlot = (props) => {
  const chartRef = useRef(null);

  let data = [];

  if (!props.hasSeries) {
    data = Object.keys(props.data).map((year) => ({ year: year, value: props.data[year] }));
  } else {
    if (Object.keys(props.data).length > 0) {
      for (const year in props.data) {
        for (const value in props.data[year]) {
          data.push({
            year: year,
            value: parseFloat(props.data[year][value].toFixed(2)),
            series: value
              .toLowerCase()
              .split(' ')
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' '),
          });
        }
      }
    }
  }

  const config = {
    data,
    padding: 'auto',
    xField: 'year',
    yField: 'value',
    ...(!props.hasSeries && { color: '#fff' }),
    ...(props.hasSeries && { seriesField: 'series' }),
    tooltip: {
      customContent: (title, items) => {
        items.sort((a, b) => b.value - a.value);

        let content = `<div class="g2-tooltip-title">${title}</div><ul class="g2-tooltip-list">`;

        items.forEach((item) => {
          content += `<li class="g2-tooltip-list-item">
                        <span class="g2-tooltip-marker" style='background-color: ${item.color}'></span>
                        <span class="g2-tooltip-name">${item.name}</span> 
                        <span class="g2-tooltip-value">${item.value}</span> 
                      </li>`;
        });

        content += '</ul>';

        return content;
      },
    },
    xAxis: {
      label: {
        style: {
          fill: 'white',
        },
      },
    },
    yAxis: {
      label: {
        style: {
          fill: 'white',
        },
      },
    },
    legend: {
      itemName: {
        style: {
          fill: 'white',
        },
      },
    },
  };

  const handleSelectAll = (event) => {
    event.preventDefault();
    const plot = chartRef.current;

    if (plot) {
      plot.chart.filter('series', (_, _2) => true);
      plot.chart.render(true);
    }
  };

  const handleUnselectAll = (event) => {
    event.preventDefault();
    const plot = chartRef.current;

    if (plot) {
      plot.chart.filter('series', (_, _2) => false);
      plot.chart.render(true);
    }
  };

  return (
    <ContextMenuTrigger id="my-context-menu-1">
      <div style={{ width: '100%', height: '20em', margin: 'auto' }}>
        <Line
          {...config}
          onReady={(plot) => {
            chartRef.current = plot;
          }}
        />
      </div>{' '}
      <ContextMenu id="my-context-menu-1">
        <ContextMenuItem onClick={handleSelectAll}>Mostrar tudo</ContextMenuItem>
        <ContextMenuItem onClick={handleUnselectAll}>Esconder tudo</ContextMenuItem>
      </ContextMenu>
    </ContextMenuTrigger>
  );
};

export default LinePlot;
